import api from './api';

export const productService = {
  // Get all products with filters
  getAllProducts: async (params = {}) => {
    const response = await api.get('/products', { params });
    return response.data?.data || response.data;
  },

  // Get featured products (best sellers and new arrivals)
  getFeaturedProducts: async () => {
    const response = await api.get('/products/featured');
    return response.data?.data || response.data;
  },

  // Get all categories
  getAllCategories: async () => {
    const response = await api.get('/products/categories');
    return response.data?.data || response.data;
  },

  // Get products by category
  getProductsByCategory: async (categorySlug, params = {}) => {
    const response = await api.get(`/products/category/${categorySlug}`, {
      params,
    });
    return response.data?.data || response.data;
  },

  // Get best sellers
  getBestSellers: async (params = {}) => {
    const response = await api.get('/products/best-sellers', { params });
    return response.data?.data || response.data;
  },

  // Get new arrivals
  getNewArrivals: async (params = {}) => {
    const response = await api.get('/products/new-arrivals', { params });
    return response.data?.data || response.data;
  },

  // Search products
  searchProducts: async (query, params = {}) => {
    const response = await api.get('/products/search', {
      params: { q: query, ...params },
    });
    return response.data?.data || response.data;
  },

  // Get product by slug (with similar products)
  getProductBySlug: async slug => {
    const response = await api.get(`/products/${slug}`);
    const data = response.data?.data || response.data;

    // Backend returns { product, relatedProducts }
    // Fallback to raw data shape if backend hasn't been updated yet
    const product = data?.product || data;
    const relatedProducts = data?.relatedProducts || [];

    return { product, relatedProducts };
  },
};
